import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import ReactDatePicker from 'react-datepicker';
import saveWorld from '../../assets/img/save-world.png';
import { CustomHeader } from './custom-header';
import { HttpService } from '../../services/apiService';

import _gConstants from '../../configuration/constants.json';
import _gEndpoints from '../../configuration/endPoints.json';
import Notifs from '../notification/notification';

import 'react-datepicker/src/stylesheets/datepicker.scss';
import './emailStyles.scss';

const _gHttpService = new HttpService();

export function Email({ oldEmail, setShowEmailValidationForm, setValidationState, uid, validationState }) {
    //#region constants
    const fieldLabelTexts = {
        validateButton: 'E-Mail-Adresse bestätigen',
        doItLaterButton: 'Mach es später',
        dob: 'Geburtsdatum (TT.MM.JJJJ)',
        email: 'E-Mail',
        confirmEmail: 'E-Mail Wiederholung'
    };
    const fieldPlaceholderTexts = {
        email: 'Trag Deine E-Mail-Adresse ein',
        confirmEmail: 'Bitte bestätige Deine E-Mail-Adresse',
        dob: 'Wähl ein Datum aus (TT.MM.JJJJ)'
    };
    const fieldErrorTexts = {
        emailEmpty: 'Bitte geben Sie eine E-Mail-Adresse ein',
        emailInvalid: 'Bitte geben Sie eine GÜLTIGE E-Mail-Adresse ein',
        confirmEmailEmpty: 'Dieses Feld darf nicht leer sein',
        confirmEmailInvalid: 'Bestätigungs-E-Mail sollte mit der E-Mail übereinstimmen',
        confirmEmailPatternInvalid: 'E-Mail-Adresse ungültig',
        dobEmpty: 'Geburtsdatum darf nicht leer sein',
        dobInvalid: 'Bitte wähl ein gültiges Geburtsdatum (TT.MM.JJJJ)',
        dobPattern: 'Das akzeptierte Muster ist TT.MM.JJJJ'
    };
    const validationTexts = {
        errorWrongDOB: 'Das Datum ist nicht das Geburtsdatum des Vertragsnehmers. Bitte prüf das Datum.',
        errorWrongDOBLimit: 'Du hast die maximale Anzahl an Versuchen erreicht. Bitte meld Dich bei unserem Kundenservice.',
        successEmailValidated: 'Danke! Wir haben Deine E-Mail-Adresse erfolgreich bestätigt.',
        errorNewMailAdd: 'Wir können Deine E-Mail-Adresse gerade leider nicht bestätigen. Du bekommst eine Extra-Nachricht. Damit kannst Du die E-Mail-Adresse bestätigen.',
        successEmailUpdated: 'Danke! Wir haben Deine E-Mail-Adresse geändert und erfolgreich bestätigt.',
        errorGeneric: 'Wir können Deine E-Mail-Adresse gerade leider nicht bestätigen. Du bekommst eine Extra-Nachricht. Damit kannst Du die E-Mail-Adresse bestätigen.'
    };

    const popupHeadings = {
        errorWrongDOB: 'Operation fehlgeschlagen! \nVersuche es nochmal',
        errorWrongDOBLimit: 'Operation fehlgeschlagen! \nVersuche es nochmal',
        successEmailValidated: 'Erfolg!',
        successEmailUpdated: 'Erfolg!',
        errorGeneric: 'Operation fehlgeschlagen! \nVersuche es nach einer Weile erneut',
    }
    const hintText = 'Tipp Deine E-Mail-Adresse zur Sicherheit ein';

    const years = Array.apply(null, Array(new Date().getFullYear() + 1 - 1930)).map(function (_, i) {
        return new Date().getFullYear() - i;
    });
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November',
        'December'];
    //#endregion

    //#region states
    const [showHint, setShowHint] = useState(false);
    const [show, setShow] = useState(true);
    const [dobError, setDobError] = useState(false);
    const [showNotif, setShowNotif] = useState(true);
    //#endregion

    // useform validation for email
    const defaultValues = { 'inputEmailAddress': oldEmail, 'dob': null }
    const { formState: { errors }, handleSubmit, watch, control, reset, setValue } = useForm({ defaultValues });

    //#region utuility function to prevent customer from performing operations such as copy/paste and hide email screen
    const preventDefault = (event) => {
        event.preventDefault();
        setShowHint(true);
        setTimeout(() => setShowHint(false), 5000);
        return false;
    }

    const hide = () => {
        setShow(false);
        setTimeout(() => setShowEmailValidationForm(false), 300);
        return
    }
    //#endregion

    //#region call anypoint for validating or updating customer's email
    function validate(body) {
        _gHttpService.callMiddleware(_gEndpoints[process.env.NODE_ENV].HOST,
            _gEndpoints[process.env.NODE_ENV].VALIDATION_ENDPOINT, process.env.REACT_APP_CI_EECC_FE_SECRET, uid,
            'POST', JSON.stringify(body))
            .then(response => {
                let errorDescription = response?.status?.hasOwnProperty('errors') ?
                    response?.status?.errors[0]?.description || 'null' : 'null';
                if (response?.status?.success === false) {
                    reset(defaultValues);
                    if (errorDescription.toLowerCase().indexOf('maximum attempts of invalid dob are over') > -1) {
                        setValidationState({
                            complete: true,
                            type: 'fail',
                            message: validationTexts.errorWrongDOBLimit,
                            popupHeading: popupHeadings.errorWrongDOBLimit,
                            showTimer: false
                        });
                        return hide();
                    }
                    setValidationState({
                        complete: true,
                        type: 'fail',
                        message: validationTexts.errorWrongDOB,
                        popupHeading: popupHeadings.errorWrongDOB,
                        showTimer: true
                    });
                    return;
                } else if (response?.status?.success === true) {
                    setValidationState({
                        complete: true,
                        type: 'success',
                        message: validationTexts.successEmailValidated,
                        popupHeading: popupHeadings.successEmailValidated,
                        showTimer: false
                    });
                    hide();
                    return;
                } else {
                    reset(defaultValues);
                    setValidationState({
                        complete: true,
                        type: 'error',
                        message: validationTexts.errorGeneric,
                        popupHeading: popupHeadings.errorGeneric,
                        showTimer: true
                    });
                    return;
                }
            })
            .catch(error => {
                // console.log(error);
                reset(defaultValues);
                setValidationState({
                    complete: true,
                    type: 'error',
                    message: validationTexts.errorGeneric,
                    popupHeading: popupHeadings.errorGeneric,
                    showTimer: true
                });
                return;
            });
    }

    function updateEmail(body) {
        _gHttpService.callMiddleware(_gEndpoints[process.env.NODE_ENV].HOST, _gEndpoints[process.env.NODE_ENV].NEW_EMAIL,
            process.env.REACT_APP_CI_EECC_FE_SECRET, uid, 'POST', JSON.stringify(body))
            .then(response => {
                if (response?.status?.success === false) {
                    reset(defaultValues);
                    setValidationState({
                        complete: true,
                        type: 'fail',
                        message: validationTexts.errorGeneric,
                        popupHeading: popupHeadings.errorGeneric,
                        showTimer: true
                    });
                    return;
                } else if (response?.status?.success === true) {
                    setValidationState({
                        complete: true,
                        type: 'success',
                        message: validationTexts.successEmailUpdated,
                        popupHeading: popupHeadings.successEmailUpdated,
                        showTimer: false
                    });
                    hide();
                    return;
                } else {
                    reset(defaultValues);
                    setValidationState({
                        complete: true,
                        type: 'error',
                        message: validationTexts.errorGeneric,
                        popupHeading: popupHeadings.errorGeneric,
                        showTimer: true
                    });
                    return;
                }
            })
            .catch(error => {
                reset(defaultValues);
                setValidationState({
                    complete: true,
                    type: 'error',
                    message: validationTexts.errorGeneric,
                    popupHeading: popupHeadings.errorGeneric,
                    showTimer: true
                });
                return;
            });
    }
    //#endregion

    const check = () => {
        let dateOfBirth = watch('dob');
        if (dateOfBirth == null) return
        if ((dateOfBirth?.toLocaleDateString().split('/')[0] == dateOfBirth?.toLocaleDateString().split('/')[1]) &&
            dateOfBirth.toLocaleDateString().split('/')[2] > new Date().getFullYear()) {
            setDobError(() => true);
            setValue('dob', null);
        }
    }

    function onFormSubmit(data) {
        let body = {}
        setDobError(false);
        if (data.hasOwnProperty('confirmEmailAddress') &&
            data.confirmEmailAddress?.length > 2 && data?.inputEmailAddress !== oldEmail) {
            body.newCustomerEmail = data.confirmEmailAddress || data?.inputEmailAddress;
            updateEmail(body);
        } else {
            body.email = data.inputEmailAddress;
            body.dob = `${data.dob.getFullYear()}-${data.dob.getMonth() < 10 ? '0' + (data.dob.getMonth() + 1) : (data.dob.getMonth() + 1)}-${data.dob.getDate() < 10 ? '0' + data.dob.getDate() : data.dob.getDate()}`;
            validate(body);
        }
    }

    const onFormError = (error) => {
        setDobError(false);
        if (error?.dob?.message === 'pattern') {
            setValue('dob', null, { shouldDirty: true })
        }
    }

    const closeNotif = () => {
        setShowNotif(false);
    }

    useEffect(() => {
        document.getElementById('email-form')
            .addEventListener("contextmenu", (event) => {
                preventDefault(event);
            });
    })

    return (
        <>
            {showNotif && <Notifs
                text={'Vielen Dank für Deine Bestellung! Du bekommst von uns eine Bestätigung per E-Mail. Da erfährst Du wie’s weitergeht. Viel Spaß mit Deinem neuen Produkt.'}
                showProgress={false}
                variant={'success'}
                showCloseBtn={true}
                closeNotif={closeNotif} />}
            <div id='email-form' className={show ? 'email-container' : 'email-container hide'}>
                <strong>Lieber Vodafone-Kunde – hilf uns dabei, die Umwelt zu schonen.</strong>
                <p>Stell jetzt auf E-Mail-Versand um. Persönliches bekommst Du weiter per Post – wie z.B. Deine PIN.</p>
                <p>Trag nur das Geburtsdatum des Vertragsnehmers ein.
                Bestätige dann die angegebene oder eine alternative E-Mail-Adresse. </p>
                <div className='form-wrapper'>
                    {showHint ? <p className='form-error' style={{ flex: '1 0 100%' }}>{hintText}</p> : ''}
                    <form className='email-form' autoComplete='off' onSubmit={handleSubmit(onFormSubmit, onFormError)}>

                        <label htmlFor='inputemailAddress' className='form-label'>{fieldLabelTexts.email}</label>
                        <Controller
                            className={errors.inputEmailAddress && 'form__input--error'}
                            autoComplete='none'
                            render={({ field }) => <input {...field}
                                type='text'
                                name='inputemailAddress'
                                placeholder={fieldPlaceholderTexts.email}
                                autoComplete='none'
                                onPaste={preventDefault}
                                onCopy={preventDefault}
                                readOnly={validationState?.complete}
                            />}
                            name='inputEmailAddress'
                            control={control}
                            rules={{
                                required: true,
                                pattern: /^[a-zA-Z0-9.!#$_-]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/
                            }}
                        />
                        {errors?.inputEmailAddress && errors.inputEmailAddress.type === 'required' &&
                            <span role='alert' className='form-error'>{fieldErrorTexts.emailEmpty}</span>}
                        {errors?.inputEmailAddress && errors.inputEmailAddress.type === 'pattern' &&
                            <span role='alert' className='form-error'>{fieldErrorTexts.emailInvalid}</span>}

                        {watch('inputEmailAddress') !== oldEmail ?
                            <div className='d--flex'>
                                <label htmlFor='confirmEmailAddress' className='form-label'>
                                    {fieldLabelTexts.confirmEmail}</label>
                                <Controller
                                    className={errors.confirmEmailAddress && 'form__input--error'}
                                    autoComplete='none'
                                    render={({ field }) => <input {...field}
                                        type='text'
                                        name='confirmEmailAddress'
                                        placeholder={fieldPlaceholderTexts.confirmEmail}
                                        autoComplete='none'
                                        onPaste={preventDefault}
                                        onCopy={preventDefault}
                                        readOnly={validationState?.complete}
                                    />}
                                    name='confirmEmailAddress'
                                    control={control}
                                    rules={{
                                        required: true,
                                        pattern: /^[a-zA-Z0-9.!#$_-]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/,
                                        validate: (value) => value === watch('inputEmailAddress')
                                    }}
                                />
                                {errors?.confirmEmailAddress && errors.confirmEmailAddress.type === 'required' &&
                                    <span role='alert' className='form-error'>{fieldErrorTexts.confirmEmailEmpty}</span>}
                                {errors?.confirmEmailAddress && errors.confirmEmailAddress.type === 'validate' &&
                                    <span role='alert' className='form-error'>{fieldErrorTexts.confirmEmailInvalid}</span>}
                                {errors?.confirmEmailAddress && errors.confirmEmailAddress.type === 'pattern' &&
                                    <span role='alert' className='form-error'>{fieldErrorTexts.confirmEmailPatternInvalid}</span>}
                            </div>
                            : null
                        }

                        <div className='datepicker__wrapper'>
                            <label className='form-label ' htmlFor='dob'>{fieldLabelTexts.dob}</label>
                            <Controller
                                className={errors.dob && 'form__input--error'}
                                control={control}
                                name='dob'
                                rules={{
                                    required: true,
                                    pattern: /\d{2}(\/|-|\.)\d{2}(\/|-|\.)\d{4}/,
                                    validate: value => {
                                        if (new Date(value) > new Date() &&
                                            new Date(value).getFullYear() < 1930) {
                                            return 'invalid date'
                                        } else if ((value?.toLocaleDateString().split('/')[0] == value?.toLocaleDateString().split('/')[1]) &&
                                            value.toLocaleDateString().split('/')[2] > new Date().getFullYear()) {
                                            return 'pattern'
                                        }
                                    }
                                }}
                                render={({ field }) => (
                                    <ReactDatePicker {...field}
                                        renderCustomHeader={({
                                            date,
                                            changeYear,
                                            changeMonth,
                                            decreaseMonth,
                                            increaseMonth,
                                            prevMonthButtonDisabled,
                                            nextMonthButtonDisabled,
                                        }) => (<CustomHeader
                                            date={date}
                                            decreaseMonth={decreaseMonth}
                                            prevMonthButtonDisabled={prevMonthButtonDisabled}
                                            changeYear={changeYear}
                                            changeMonth={changeMonth}
                                            increaseMonth={increaseMonth}
                                            nextMonthButtonDisabled={nextMonthButtonDisabled}
                                            years={years}
                                            months={months}
                                        />)}
                                        className='input'
                                        dateFormat='dd.MM.yyyy'
                                        placeholderText={fieldPlaceholderTexts.dob}
                                        onChange={(e) => field.onChange(e)}
                                        selected={field.value}
                                        onBlur={check}
                                    />
                                )}
                            />
                            {errors?.dob && errors.dob.type === 'required' &&
                                <span role='alert' className='form-error'>{fieldErrorTexts.dobEmpty}</span>}
                            {(dobError || errors?.dob && (errors.dob.type === 'pattern' || errors.dob.message === 'pattern')) &&
                                <span role='alert' className='form-error'>{fieldErrorTexts.dobPattern}</span>}
                            {errors?.dob && errors.dob.type === 'validate' && errors.dob.message != 'pattern' &&
                                < span role='alert' className='form-error'>{fieldErrorTexts.dobInvalid}</span>}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                            <button type='submit'
                                className={validationState?.complete ? 'email-btn-disabled' : 'btn email--button'}
                                disabled={validationState?.complete}>{fieldLabelTexts.validateButton}</button>
                            {/* <button type='submit' className='btn email--button' onClick={hide}>{fieldLabelTexts.doItLaterButton}</button> */}
                        </div>
                    </form>

                    <div className='img-container'>
                        <img src={saveWorld} alt='save world' />
                    </div>
                </div>
            </div >
        </>
    )
}